<template>
  <div>
    <b-tooltip
      :target="targetId"
      :title="tooltipText"
      v-if="tooltipText"
      :placement="placement"
      :custom-class="toolTipCustomClass"
    >
    </b-tooltip>
    <b-tooltip
      :target="targetId"
      v-else
      :placement="placement"
      :custom-class="toolTipCustomClass"
    >
      <slot name="tooltip-content"></slot
    ></b-tooltip>
    <slot :name="iconSlotName" v-if="iconSlotName"></slot>
    <i :id="targetId" class="fa fa-info-circle info-icon" v-else></i>
  </div>
</template>
<script>
export default {
  name: 'CustomTooltip',
  props: {
    targetId: {
      type: String,
      required: true,
    },
    tooltipText: {
      type: String,
      required: false,
      default: '',
    },
    iconSlotName: {
      type: String,
      required: false,
      default: '',
    },
    toolTipCustomClass: {
      type: String,
      required: false,
      default: '',
    },
    placement: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>
<style scoped>
.info-icon {
  color: #0075ff;
}
</style>
